<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">Reportes</h4>
                    <div class="bg-light p-3 reportes-container">
                        <div>
                            <h6>Seleccione fechas</h6>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                Fecha inicial
                                <div>
                                    <input type="date" class="form-control" v-model="dateStart">
                                </div>
                            </div>
                            <div class="col-6">
                                Fecha final
                                <div>
                                    <input type="date"  class="form-control" v-model="dateEnd">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                Filtrar por usuario
                                <div>
                                    <select class="form-control" v-model="userSelect">
                                        <option value="_all_">Todos</option>
                                        <option v-for="item in userList" :value="item">{{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <h6>Seleccione el reporte a generar</h6>
                        </div>
                        <div class="row m-0 reporte-btns-container">
                            <div class="p-1 btn__reporte">
                                <div @click="generateReport('primas')" class="item-menu item-reporte">
                                    Pago de primas
                                </div>
                            </div>
                            <div class="p-1 btn__reporte">
                                <div @click="generateReport('primas_nuevo')" class="item-menu item-reporte">
                                    Pago de primas (nuevo)
                                </div>
                            </div>
                            <div class="p-1 btn__reporte">
                                <div @click="generateReport('deducibles')" class="item-menu item-reporte">
                                    Pago de deducibles
                                </div>
                            </div>
                            <div class="p-1 btn__reporte">
                                <div @click="generateReport('recobros')" class="item-menu item-reporte">
                                    Pago de recobros
                                </div>
                            </div>
                            <div class="p-1 btn__reporte">
                                <div @click="generateReport('ruta_cobros')" class="item-menu item-reporte">
                                    Ruta de cobros
                                </div>
                            </div>
                            <!--<div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Siniestros
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> recobro
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Salvamentos
                                </div>
                            </div>-->
                            <!--<div class="col-6 p-1">
                                <div @click="visanet" class="item-menu">
                                    Pago Visanet
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";
import API from "src/core/Api";
import {store} from "src/store";
import dayjs from "dayjs";


export default {
    props: {
    },
    components: {
        //TimelineChart,
        Layout,
        //Toster,
    },
    data(){
        return  {
            dateStart: "",
            dateEnd: "",
            userSelect: "_all_",
            userList: {}
        }
    },
    mounted() {
        this.dateStart = dayjs().format('YYYY-MM-DD');
        this.dateEnd = dayjs().format('YYYY-MM-DD');
        this.getUsers();
    },
    methods: {
        generateReport(typeReport) {
            const self = this;
            API.send('GET', "report/" + typeReport + "/" + this.dateStart + "/" + this.dateEnd + '/' + self.userSelect, false,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/rpt/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
            //window.open(CONFIG.getWsUrl());
        },
        getUsers() {
            const self = this;
            API.send('GET', "report-get-user", false,
                function (response) {
                    store.dispatch('coreHideLoading');

                    self.userList = response.data;
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
        }
        /*visanet() {
            const test = new AndroidBridge();
            test.VisanetPayApp();
        }*/
    }
};
</script>
